<script type="text/ecmascript-6">
    import DesignerQuestionDoorRange from "../DesignerQuestionDoorRange.vue";

    export default {
        mixins: [
            DesignerQuestionDoorRange
        ],
        computed: {
            thumbURL() {
                return '/images/barbican/';
            },
        },
        methods: {
            switch_range(range) {
                window.emitter.emit('new-door', this.defaultdoor[range], this.reference_on);
                window.emitter.emit('range-updated');
            },
        },
    }
</script>
